import ky from 'ky';

import { getEnvOrThrow } from 'utils/getEnv';

export const httpClient = ky.extend({
  prefixUrl: getEnvOrThrow('REACT_APP_ROOT_URL'),
  credentials: 'include',
});
